export const envConstants = {
  momentFormat: 'LLL',
  anomalyTypes: [
    'attraversamento',
    'avvallamento',
    'buca',
    'chiusino',
    'crepa',
    'dosso',
    'gibbosita',
    'giunto',
    'percorrenza',
    'porfido',
    'radice',
    'rappezzo',
    'rotaia',
    'scavo',
    'screpolatura',
    'tombino',
    'traccia',
    'altro'
  ],
  ls: {
    bearer: 'com.anomaleet.suite.bearer',
    email: 'com.anomaleet.suite.email',
    time: 'com.anomaleet.suite.time',
    dashboard_form: 'com.anomaleet.suite.dashboard_form',
    missions: 'com.anomaleet.suite.missions'
  },
  upload: {
    saved_locally: 1,
    must_be_sent: 2,
    sent: 3
  }
}
